(function (root) {
  'use strict';
  const STOP = new Set('a an and or the with without in on of for to from by at it its your you our this that these those is are be as all each which who what only no not em solid sterling silver gold rosegold vermeil plated plating brass 925 18k 18ct 14k 24k ring rings pendant pendants necklace necklaces neckchain neckchains chain chains bracelet bracelets cuff cuffs earring earrings jewelry jewellery product products collection collections size sizes mm cm g grams gram approx approximately handcrafted handmade hand crafted bali premium quality timeless unique style stylish piece pieces design designs detail details detailing finished finish individually made custom set featuring statement perfect iconic bold polished polish water safe warranty free shipping upsell category metal'.split(' '));
  const GROUPS = [
    ['tiger', 'panther', 'leopard', 'lion'],
    ['heart', 'lover', 'soulmate', 'kissing', 'couple', 'promise'],
    ['sun', 'moon', 'star', 'celestial'],
    ['rose', 'thorn', 'floral', 'flower'],
    ['cross', 'angel', 'mary', 'pray'],
    ['skull', 'grim', 'reaper', 'bone'],
    ['fuck', 'rebel', 'freedom', 'risk', 'middlefinger'],
    ['curb', 'figaro', 'link'],
    ['engrave', 'initial', 'personal', 'locket']
  ];
  const STONES = new Set(['ruby', 'emerald', 'sapphire', 'lapis', 'garnet', 'onyx', 'quartz', 'marble', 'crystal']);
  const COLOURS = new Set(['red', 'blue', 'green', 'brown', 'pink', 'purple', 'black', 'white', 'grey', 'yellow']);
  const FORMS = new Set(['signet', 'band', 'enamel', 'gemstone', 'stone', 'hammered', 'oxidized', 'vintage', 'carved', 'texture', 'floral', 'minimal', 'chunky', 'oval', 'round', 'square']);
  function normalise(value) {
    return String(value || '').normalize('NFKD').toLowerCase()
      .replace(/barb(?:ed)?[ -]?wire|bard wire/g, 'barbwire')
      .replace(/middle finger/g, 'middlefinger')
      .replace(/rose gold/g, 'rosegold')
      .replace(/oynx/g, 'onyx').replace(/lapiz/g, 'lapis').replace(/shappire/g, 'sapphire')
      .replace(/gemtstone/g, 'gemstone').replace(/grimp/g, 'grim')
      .replace(/oxided|oxidised/g, 'oxidized').replace(/engravable|engraved|engraving/g, 'engrave')
      .replace(/ladies|lady/g, 'woman').replace(/girls/g, 'girl')
      .replace(/soultmates|soulmates/g, 'soulmate').replace(/rebels/g, 'rebel')
      .replace(/gemstones/g, 'gemstone').replace(/hearts/g, 'heart').replace(/eyes/g, 'eye')
      .replace(/flowers/g, 'flower').replace(/roses/g, 'rose').replace(/initials/g, 'initial')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function words(value) {
    return [...new Set(normalise(value).split(' ').filter(w => w.length > 2 && !STOP.has(w) && !/^\d/.test(w)))];
  }
  function category(product) {
    const title = normalise(product.title);
    const tags = new Set((product.tags || []).map(t => t.toLowerCase()));
    if (tags.has('ut-category-earrings') || /\bearrings?\b/.test(title)) return 'earrings';
    if (tags.has('ut-category-bracelets') || /\b(bracelets?|cuffs?)\b/.test(title)) return 'bracelets';
    if (tags.has('ut-category-rings') || /\brings?\b/.test(title)) return 'rings';
    if (/\b(neckchains?|chains?)\b/.test(title) && !/\bpendants?\b/.test(title)) return 'chains';
    if (tags.has('ut-category-necklaces') || /\b(pendants?|necklaces?)\b/.test(title)) return 'pendants';
    return '';
  }
  function metals(product) {
    const title = normalise(product.title);
    const tags = new Set((product.tags || []).map(t => t.toLowerCase()));
    const found = [];
    if (tags.has('ut-metal-gold') || /\bgold\b|\brosegold\b/.test(title)) found.push('gold');
    if (tags.has('ut-metal-silver') || /\bsilver\b/.test(title)) found.push('silver');
    return found;
  }
  function profile(product) {
    const title = words(product.title);
    const tag = words((product.tags || []).filter(t => !/^ut-|^_/.test(t)).join(' '));
    const description = words(String(product.description || '').slice(0, 900));
    const weight = new Map();
    description.forEach(w => weight.set(w, 0.35));
    tag.forEach(w => weight.set(w, Math.max(weight.get(w) || 0, description.includes(w) ? 1.2 : 0.5)));
    title.forEach(w => weight.set(w, 3));
    const identity = new Set(title.filter(w => !FORMS.has(w) && !COLOURS.has(w) && !STONES.has(w)));
    const groups = GROUPS.flatMap((g, i) => g.some(w => identity.has(w) || (weight.get(w) || 0) >= 1.2) ? [i] : []);
    return { product, category: category(product), metals: metals(product), title, weight, identity, groups };
  }
  function createIndex(products) {
    const profiles = products.map(profile);
    const counts = new Map();
    profiles.forEach(p => p.weight.forEach((v, k) => { if (v >= 1.2) counts.set(k, (counts.get(k) || 0) + 1); }));
    return { profiles, idf: word => Math.min(3.5, 1 + Math.log((profiles.length + 1) / ((counts.get(word) || 0) + 1))) };
  }
  function score(source, candidate, index) {
    let points = 0;
    const reasons = [];
    let identityMatch = false;
    for (const [word, weight] of source.weight) {
      const other = candidate.weight.get(word) || 0;
      if (!other) continue;
      const strongest = Math.min(weight, other);
      let bonus = strongest * index.idf(word);
      if (source.identity.has(word) && candidate.identity.has(word)) {
        bonus += 22;
        identityMatch = true;
        reasons.push('motif:' + word);
      } else if (STONES.has(word) && strongest >= 1.2) {
        bonus += 12;
        reasons.push('stone:' + word);
      } else if (COLOURS.has(word) && strongest >= 1.2) {
        bonus += 6;
        reasons.push('colour:' + word);
      } else if (FORMS.has(word) && strongest >= 1.2) {
        bonus += 3;
        reasons.push('style:' + word);
      }
      points += bonus;
    }
    const groupMatches = source.groups.filter(g => candidate.groups.includes(g));
    if (groupMatches.length && !identityMatch) {
      points += 10 * groupMatches.length;
      reasons.push('theme:' + groupMatches.join(','));
    }
    const sameMetal = source.metals.some(m => candidate.metals.includes(m));
    if (sameMetal) {
      points += 7;
      reasons.push('finish:' + source.metals.filter(m => candidate.metals.includes(m)).join(','));
    }
    const plainChain = candidate.category === 'chains' && candidate.title.every(w => ['curb', 'figaro', 'link', 'minimal', 'vintage', 'classic'].includes(w));
    if (sameMetal && candidate.category === 'chains' && source.category !== 'chains' && (plainChain || identityMatch || groupMatches.length)) {
      points += source.category === 'pendants' ? 15 : 8;
      reasons.push('complement:chain');
    }
    if (source.category === candidate.category) points += 2;
    const meaningful = reasons.some(r => !r.startsWith('finish:'));
    if (reasons.length === 0) return { points: 0, reasons, meaningful: false };
    return { points, reasons, meaningful };
  }
  function recommend(current, products, tab = 'suggested', limit = 16) {
    const index = createIndex(products);
    const source = profile(current);
    const candidates = index.profiles.filter(p => p.product.available !== false && p.category &&
      String(p.product.id) !== String(current.id) && p.product.handle !== current.handle &&
      (tab === 'suggested' || p.category === tab));
    const ranked = candidates.map(p => ({ product: p.product, category: p.category, ...score(source, p, index) }))
      .filter(p => p.points > 0).sort((a, b) => b.points - a.points || a.product.handle.localeCompare(b.product.handle));
    const selected = [], counts = {}, ids = new Set();
    while (selected.length < limit && ranked.length) {
      let bestIndex = 0, bestScore = -Infinity;
      for (let i = 0; i < ranked.length; i++) {
        const item = ranked[i];
        const count = counts[item.category] || 0;
        const cap = item.category === 'chains' || item.category === 'earrings' ? 2 : 6;
        const penalty = tab === 'suggested' ? count * 2 + (count >= cap ? 35 : 0) : 0;
        const adjusted = item.points - penalty + (item.meaningful ? 1000 : 0);
        if (adjusted > bestScore) { bestScore = adjusted; bestIndex = i; }
      }
      const item = ranked.splice(bestIndex, 1)[0];
      if (ids.has(String(item.product.id))) continue;
      selected.push(item);
      ids.add(String(item.product.id));
      counts[item.category] = (counts[item.category] || 0) + 1;
    }
    return selected;
  }
  const api = { normalise, category, metals, profile, createIndex, recommend };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.UTProductRelevance = api;
})(typeof window === 'undefined' ? this : window);

(function () {
  'use strict';
  const cataloguePromises = new Map();
  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const secondaryLoads = new WeakMap();
  const secondaryQueue = [];
  let secondaryInFlight = 0;
  function drainSecondaryQueue() {
    while (secondaryInFlight < 2 && secondaryQueue.length) {
      const job = secondaryQueue.shift();
      if (!job.card.isConnected || job.card.closest('[hidden]') || !hoverPointer.matches) {
        job.cancel();
        continue;
      }
      secondaryInFlight += 1;
      job.load().finally(() => { secondaryInFlight -= 1; drainSecondaryQueue(); });
    }
  }
  const secondaryObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) secondaryLoads.get(entry.target)?.();
    });
  }, { rootMargin: '300px 0px' }) : null;
  async function readCatalogue(section) {
    const initial = new URL(section.dataset.catalogueUrl, document.baseURI);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) initial.searchParams.set('preview_theme_id', preview);
    const key = initial.href + '|' + section.dataset.currency + '|' + section.dataset.country;
    if (cataloguePromises.has(key)) return cataloguePromises.get(key);
    const cacheKey = 'ut-recommendations-v5|' + key;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.at < 60000 && Array.isArray(cached.products)) return cached.products;
    } catch (error) {}
    const request = (async () => {
      const requests = new Map();
      function readPage(page) {
        if (requests.has(page)) return requests.get(page);
        const request = (async () => {
          const url = new URL(initial);
          url.searchParams.set('page', String(page));
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 15000);
          let payload;
          try {
            const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Recommendation catalogue unavailable');
            payload = JSON.parse(await response.text());
          } finally { clearTimeout(timeout); }
          if (![1, 2].includes(payload.version) || !Array.isArray(payload.products) ||
            payload.currency !== section.dataset.currency || payload.country !== section.dataset.country ||
            !Number.isInteger(payload.pages) || payload.pages < 1 || payload.pages > 100) {
            throw new Error('Recommendation catalogue context changed');
          }
          return payload;
        })();
        requests.set(page, request);
        return request;
      }
      const hint = Math.min(4, Math.max(1, Number(section.dataset.cataloguePages) || 1));
      const initialPages = await Promise.allSettled(Array.from({ length: hint }, (_, index) => readPage(index + 1)));
      if (initialPages[0].status !== 'fulfilled') throw initialPages[0].reason;
      const pages = initialPages[0].value.pages;
      const products = [];
      for (let page = 1; page <= pages; page += 4) {
        const batch = await Promise.all(Array.from({ length: Math.min(4, pages - page + 1) }, (_, index) => readPage(page + index)));
        batch.forEach(payload => products.push(...payload.products));
      }
      const available = products.filter(p => p.available && p.image && p.price > 0 && !p.giftCard);
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), products: available })); } catch (error) {}
      return available;
    })();
    cataloguePromises.set(key, request);
    request.catch(() => cataloguePromises.delete(key));
    return request;
  }
  function imageSources(image) {
    if (image.srcset) return image.srcset;
    return [240, 360, 480, 640, 960].map(width => {
      const url = new URL(image.src, document.baseURI);
      url.searchParams.set('width', String(width));
      return url.href + ' ' + width + 'w';
    }).join(', ');
  }
  function card(product, eager) {
    const article = document.createElement('article');
    article.className = 'ut-recommendations__card';
    article.dataset.productId = product.id;
    article.dataset.productHandle = product.handle;
    const link = document.createElement('a');
    link.href = product.url;
    const imageBox = document.createElement('span');
    imageBox.className = 'ut-recommendations__image';
    const image = document.createElement('img');
    image.sizes = '(max-width: 767px) calc((100vw - 2px) / 2), calc((100vw - 6px) / 4)';
    image.width = product.image.width;
    image.height = product.image.height;
    image.alt = product.title;
    image.loading = eager ? 'eager' : 'lazy';
    image.decoding = 'async';
    image.fetchPriority = eager ? 'auto' : 'low';
    image.srcset = imageSources(product.image);
    image.src = product.image.src;
    imageBox.append(image);
    if (product.secondaryImage && product.secondaryImage.src !== product.image.src) {
      let secondaryState = 'idle';
      function queueSecondary() {
        if (!hoverPointer.matches || secondaryState !== 'idle') return;
        secondaryState = 'queued';
        secondaryQueue.push({
          card: article,
          cancel() { secondaryState = 'idle'; },
          load: () => new Promise(resolve => {
            secondaryState = 'loading';
            const secondary = document.createElement('img');
            secondary.className = 'ut-recommendations__secondary';
            secondary.alt = '';
            secondary.setAttribute('aria-hidden', 'true');
            secondary.width = product.secondaryImage.width;
            secondary.height = product.secondaryImage.height;
            secondary.sizes = image.sizes;
            secondary.decoding = 'async';
            secondary.fetchPriority = 'low';
            let settled = false;
            const timeout = setTimeout(() => finish(false), 15000);
            function finish(success) {
              if (settled) return;
              settled = true;
              clearTimeout(timeout);
              secondary.onload = secondary.onerror = null;
              if (success) {
                secondaryState = 'ready';
                imageBox.classList.add('ut-recommendations__image--secondary-ready');
                secondaryObserver?.unobserve(article);
              } else {
                secondary.remove();
                secondaryState = 'idle';
              }
              resolve();
            }
            secondary.onload = async () => {
              try { if (secondary.decode) await secondary.decode(); } catch (error) {}
              finish(secondary.naturalWidth > 0);
            };
            secondary.onerror = () => finish(false);
            secondary.srcset = imageSources(product.secondaryImage);
            secondary.src = product.secondaryImage.src;
            imageBox.append(secondary);
          })
        });
        drainSecondaryQueue();
      }
      secondaryLoads.set(article, queueSecondary);
      secondaryObserver?.observe(article);
      imageBox.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') queueSecondary();
      });
      link.addEventListener('focus', queueSecondary);
    }
    const name = document.createElement('h3');
    name.className = 'ut-recommendations__name';
    name.textContent = product.title.toLowerCase();
    const prices = document.createElement('p');
    prices.className = 'ut-recommendations__price';
    const price = document.createElement('span');
    price.textContent = product.priceText;
    prices.append(price);
    if (product.compareAt > product.price) {
      const compare = document.createElement('s');
      compare.textContent = product.compareText;
      prices.append(compare);
    }
    const info = document.createElement('span');
    info.className = 'ut-recommendations__info';
    info.append(name);
    if (product.material) {
      const material = document.createElement('span');
      material.className = 'ut-recommendations__material';
      material.textContent = product.material;
      info.append(material);
    }
    info.append(prices);
    link.append(imageBox, info);
    article.append(link);
    return article;
  }
  function initialise(section) {
    if (section.dataset.utReady) return;
    section.dataset.utReady = 'true';
    const current = JSON.parse(section.querySelector('[data-ut-current]').textContent);
    const labels = JSON.parse(section.querySelector('[data-ut-labels]').textContent);
    const tabs = [...section.querySelectorAll('[data-ut-tab]')];
    const panels = [...section.querySelectorAll('[data-ut-panel]')];
    const status = section.querySelector('[data-ut-status]');
    const retry = section.querySelector('[data-ut-retry]');
    const lists = new Map(), shown = new Map();
    let active = 'suggested', products = null, loading = false;
    function render(tab, append) {
      if (!products) return;
      const panel = panels.find(p => p.dataset.utPanel === tab);
      const grid = panel.querySelector('[data-ut-grid]');
      if (!lists.has(tab)) lists.set(tab, window.UTProductRelevance.recommend(current, products, tab, products.length));
      const matches = lists.get(tab);
      if (!append && shown.has(tab)) {
        status.textContent = matches.length ? '' : labels.empty;
        section.dataset.utCount = String(shown.get(tab));
        return;
      }
      const start = append ? shown.get(tab) || 0 : 0;
      const end = append ? Math.min(start + 16, matches.length) : Math.min(shown.get(tab) || 16, matches.length);
      const fragment = document.createDocumentFragment();
      matches.slice(start, end).forEach((match, index) => fragment.append(card(match.product, start === 0 && index < (window.innerWidth < 768 ? 2 : 4))));
      if (append) grid.append(fragment); else grid.replaceChildren(fragment);
      shown.set(tab, end);
      panel.querySelector('[data-ut-more]').hidden = end >= matches.length;
      status.textContent = matches.length ? '' : labels.empty;
      section.dataset.utCount = String(end);
    }
    async function load() {
      if (loading || products) return;
      loading = true;
      retry.hidden = true;
      section.setAttribute('aria-busy', 'true');
      status.textContent = labels.loading;
      try {
        products = await readCatalogue(section);
        render(active, false);
      } catch (error) {
        status.textContent = labels.error;
        panels.forEach(panel => panel.querySelector('[data-ut-grid]').replaceChildren());
        retry.hidden = false;
      } finally {
        loading = false;
        section.setAttribute('aria-busy', 'false');
      }
    }
    function select(tab, focus) {
      active = tab.dataset.utTab;
      tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
      panels.forEach(p => { p.hidden = p.dataset.utPanel !== active; });
      if (focus) tab.focus();
      render(active, false);
      load();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
      });
    });
    panels.forEach(panel => panel.querySelector('[data-ut-more]').addEventListener('click', () => render(panel.dataset.utPanel, true)));
    retry.addEventListener('click', load);
    const warm = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 300 });
      else load();
    };
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm, { once: true });
    window.addEventListener('scroll', load, { once: true, passive: true });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
      }, { rootMargin: '1800px 0px' });
      observer.observe(section);
    } else load();
  }
  document.querySelectorAll('[data-ut-recommendations]').forEach(initialise);
  document.addEventListener('ut:recommendations:ready', () => document.querySelectorAll('[data-ut-recommendations]').forEach(initialise));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ut-recommendations]').forEach(initialise));
})();
